import * as React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Title from "./TabTitle";
import { useLocation, useNavigate, useParams, useMatch } from "react-router-dom";
import { addTab, removeTab, useTabs, TAB_TYPES } from "slices/tabsSlice";
import { Tabs } from "components/Enums/TabEnums.ts";
import { useAllowedLiscence } from "hooks/useAllowedLiscence";
import AccessRevokedModal from "components/common/AccessRevokedModal";
import ConsultantsList from "pages/Consultant/ConsultantsList";
import ConsultantLedger from "pages/Consultant/ConsultantLedger";
import PayConsultant from "pages/Consultant/PayConsultant";

const ConsultantTabs = React.memo((props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabs, setTabs] = React.useState([]);
  const tabsData = useTabs(TAB_TYPES.CONSULTANT);
  const { allowed } = useAllowedLiscence(Tabs.CONSULTANT);

  const findContent = (item) => {
    switch (item) {
      case "consultants":
        return "Consultants";
      case "consultantledger":
        return "Consultant Ledger";
      case "payconsultant":
        return "Pay Consultant";

      default:
        break;
    }
  };

  const urlDefiner = (e) => {
    if (params !== null) {
      let url = tabs[e]?.toLowerCase();
      if (url === undefined) {
        url = "";
      }
      // window.history.replaceState(null, '', `/nominal/${url}`)
      navigate(`/consultant/${url}`);
    }
  };

  const params = useMatch("consultant/:data");

  useEffect(() => {
    if (params !== null) {
      let data = params?.params?.data;
      if (!tabsData.includes(data?.toLowerCase())) {
        dispatch(addTab("consultant", data?.toLowerCase()));
        dispatch(removeTab("purchase", "Suppliers"));
      } else {
        setSelected(tabsData.indexOf(data?.toLowerCase()));
      }
    }
  }, [params]);

  useEffect(() => {
    if (tabsData) {
      setTabs(tabsData);
      let index = tabsData.indexOf(params?.params?.data.toLowerCase());
      setSelected(index === -1 ? 0 : index);
    }
  }, [tabsData]);

  const removeTabDispatcher = (tab) => {
    const closedIndex = tabs.findIndex((t) => findContent(t) === tab);
    const newTabs = tabs.filter((t) => findContent(t) !== tab);
    if (!newTabs.length) {
      navigate("/");
      setSelected(0);
      dispatch(removeTab("consultant", tabs[closedIndex]));
      dispatch(removeTab("purchase", tabs[closedIndex]));
      return;
    }
    const newSelected =
      closedIndex === selected
        ? Math.min(selected, newTabs.length - 1)
        : closedIndex < selected
          ? selected - 1
          : selected;
    setSelected(newSelected);
    navigate(`/consultant/${newTabs[newSelected]?.toLowerCase() ?? ""}`);
    dispatch(removeTab("consultant", tabs[closedIndex]));
    dispatch(removeTab("purchase", tabs[closedIndex]));
  };

  const [selected, setSelected] = React.useState(-1);

  const handleSelect = (e) => {
    urlDefiner(e.selected);
  };

  return allowed ? (
    <TabStrip
      selected={selected}
      onSelect={handleSelect}
      keepTabsMounted={true}
      className="navigationTabs">
      {tabs.map((item, index) => {
        return (
          item && (
            <TabStripTab
              title={
                <Title
                  content={findContent(item)}
                  onTabRemove={removeTabDispatcher}
                  selected={findContent(tabs.at(selected))}
                  count={tabs.length}
                />
              }
              key={index}>
              <div style={{ height: "100%" }}>
                {item === "consultants" && <ConsultantsList />}
                {item === "consultantledger" && <ConsultantLedger />}
                {item === "payconsultant" && <PayConsultant />}
              </div>
            </TabStripTab>
          )
        );
      })}
    </TabStrip>
  ) : (
    <AccessRevokedModal removeTab={() => props.closeTab()} />
  );
});

export default ConsultantTabs;
